import { render, staticRenderFns } from "./CHART_PREFECTURE.vue?vue&type=template&id=28058641&scoped=true"
import script from "./CHART_PREFECTURE.vue?vue&type=script&lang=ts"
export * from "./CHART_PREFECTURE.vue?vue&type=script&lang=ts"
import style0 from "./CHART_PREFECTURE.vue?vue&type=style&index=0&id=28058641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28058641",
  null
  
)

export default component.exports